module.exports = __webpack_public_path__ + "static/media/asurion-logo-white.c38cd6fa.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/components/resources/asurion-logo-white.svg
// module id = 3368
// module chunks = 0